import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { S_Link } from '../../../../design/links/S_Link';
import { useLoader } from '../../../helpers/useLoader';
import { Home } from '../../../routes/config/Home';
import { IProjectPreviewService } from '../../projectDetails/services/projectPreview.service';

export const PreviewControlsContainer = observer((): ReactElement => {
  const projectPreviewService = useInjection(IProjectPreviewService.$);

  const { withLoaderAsync } = useLoader();
  const { t } = useTranslator();
  const { projectId, workspaceId } = useParams<{ projectId: string; workspaceId: string }>();

  useEffect(() => {
    const setupAsync = async (): Promise<void> => {
      await withLoaderAsync(async () => projectPreviewService.setupAsync(projectId));
    };

    void setupAsync();

    return (): void => {
      projectPreviewService.dispose();
    };
  }, [projectId]);

  return (
    <S_Link
      color='text'
      className='back'
      to={Home.Projects.Details.AnnotationView.withParams({
        workspaceId: workspaceId,
        projectId: projectId,
      })}
    >
      <Button startDecorator={<FontAwesomeIcon icon='angle-left' />}>{t('back_to_wizard')}</Button>
    </S_Link>
  );
});
